// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flags-wrap[data-v-447feeec]{margin-top:25px;overflow-y:scroll;height:500px}.flags-wrap span[data-v-447feeec]{margin-left:15px;position:relative;top:-2px}.token-text[data-v-447feeec]{resize:none;height:75px}", ""]);
// Exports
module.exports = exports;
